import { gql } from '@apollo/client';
const GET_USER_NOTIFICATION_EVENTS = gql`
subscription userNotificationEvents($authToken: String!){
	userNotificationEvents(authToken:$authToken)
	{
		actor{
			avatarUrl
			name
			username
		}
		
		aggregationCount
		createdAt
		eventChannel
		eventId
						folderPayload
				{
					folderId
					folderName
				}
				resourcePayload
				{
					 folderId
					resourceId
					resourceName
				}
		readAt
		siteId
		siteName
		updatedAt
		userId
		userNotificationId
		__typename		
	}
}`;

export default GET_USER_NOTIFICATION_EVENTS;



